import { Box, Grid, Typography } from "@material-ui/core";
import { assetIds, InformationMessage, ThemedAsset } from "nemuru-components";
import React, { useContext, useEffect } from "react";
import { ICON_TITLE_HEIGHT } from "../../../../../config/config";
import IconTitle from "../../../../shared/components/IconTitle";
import MainButton from "../../../../shared/components/MainButton";
import Text from "../../../../shared/components/Text";
import { useTheme } from "@material-ui/styles";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import { constructProgressEvent } from "../../../../../utils/constructProgressEvent";
import { useEventDispatcher } from "../../../../../utils/hooks/useEventDispatcher";
import { getMode } from "../../../../../utils/getMode";

export default function SignatureUrlRedirect() {
  const {
    state: { signatureChannel, currentModuleObject },
  } = useContext(ProcessContext);
  const { palette } = useTheme();

  const { dispatchEvent } = useEventDispatcher();
  useEffect(() => {
    const progressEvent = constructProgressEvent(
      currentModuleObject?.id,
      "SIGNATURE_URL_REDIRECT"
    );
    dispatchEvent(progressEvent);
  }, []);

  const proceedToSign = () => {
    const mode = getMode();
    if (mode === "embedded") {
      window.parent.postMessage(
        {
          messageId: "redirectUrl",
          payload: { url: signatureChannel.url },
        },
        "*"
      );
      return;
    }
    location.href = signatureChannel.url;
  };

  return (
    <>
      <Box className="appear-anim">
        <Box style={{ height: "5vh" }} />
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_DOC_SIGNATURE}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId={"CONTRACT_SIGNATURE"} />}
          subtitle={<Text tId="FOLLOW_INSTRUCTIONS_TO_SIGN" />}
        />
        <Box style={{ height: "5vh" }} />
        <Grid container justifyContent="center" alignItems="center">
          {signatureChannel && (
            <InformationMessage
              variant={{
                type: "info",
                icon: (
                  <i
                    className="material-icons-outlined"
                    style={{ fontSize: 20 }}
                  >
                    info
                  </i>
                ),
              }}
              isScreenXs={true}
              messageContent={{
                body: (
                  <Box p={2}>
                    <Typography
                      variant={"body2"}
                      style={{
                        color: palette.text.title,
                        textAlign: "center",
                      }}
                    >
                      <strong>{signatureChannel.action}</strong>
                    </Typography>
                  </Box>
                ),
              }}
            />
          )}
        </Grid>
      </Box>
      <Box>
        <MainButton
          onClick={() => {
            proceedToSign();
          }}
        >
          <Text tId="SIGN" />
        </MainButton>
      </Box>
    </>
  );
}
